import React from 'react';
import { UncontrolledDropdown } from 'reactstrap';

export const QUncontrolledDropdown = props => (
  <UncontrolledDropdown {...props} />
);
